require("./assets/js/lang.js");
// require("./assets/js/ball.js");
require("./assets/js/init.js");

require("./assets/js/b_canvas.js");

import BColor from './b_utils/b_color.js';
import BAjax from './b_utils/b_ajax.js';
import BApp from './b_utils/b_app.js';

require("./handle_safe.js");
require("./focus_win.js");

$(document).ready(function () {
  if (BApp.isProduct()) {
    // 统计访问量
    BAjax.post({
      url: 'visit/',
      url_root: "/stats/",
      data: {
        url: window.location.href
      },
      success: (data) => {
      }
    });
  }

  $("#smart-kanban-title").html(`
  <span style="color: ` + BColor.getRainbowColorFormatRGB(0) + `;">智</span><span style="color: ` + BColor.getRainbowColorFormatRGB(1) + `;">能</span><span
              style="color: ` + BColor.getRainbowColorFormatRGB(2) + `;">看</span><span style="color: ` + BColor.getRainbowColorFormatRGB(3) + `;">板</span>
  `)
});